import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkLineDto } from '@app/generated/model';
import { WorkLineModel, WorkOrderObjectModel } from '@app/work-order/objects/work-order-object.model';
import { Store } from '@ngrx/store';
import { getSelectedWorkLines } from '@app/core/store/selectors/work-order.selector';
import { DeselectWorkLine, SelectWorkLine } from '@dwo/actions';

@Component({
  selector: 'app-work-line-percentage',
  templateUrl: './work-line-percentage.component.html',
  styleUrls: ['./work-line-percentage.component.scss'],
  standalone: false,
})
export class WorkLinePercentageComponent implements OnInit {
  @Input() workLine: WorkLineDto;
  @Output() selected = new EventEmitter<WorkOrderObjectModel>();
  public isSelected = false;
  public indentationPerStep = 18;
  public level = 0;
  public indentationStartingPoint = 20;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.select(getSelectedWorkLines).subscribe((selectedWorkLines) => {
      if (selectedWorkLines.length > 0) {
        this.isSelected = selectedWorkLines.some((wl) => wl.id === this.workLine.id);
      } else {
        this.isSelected = false;
      }
    });
  }

  public toggleSelectedWorkLine(workLine: WorkLineModel) {
    if (!workLine.isSelected) {
      this.store.dispatch(new SelectWorkLine(workLine));
    } else {
      this.store.dispatch(new DeselectWorkLine(workLine));
    }
  }

  public getIndentation(): number {
    return this.indentationStartingPoint + this.indentationPerStep * this.level + this.indentationPerStep;
  }

  public getProgressLabel(progress: number) {
    return `${Math.floor(progress).toFixed(0)} %`;
  }
}
